<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Global from "@/constants/Global.js";

export default {
  data() {
    return {
      emojis: [
        0x1f632, 0x1f61c, 0x1f604, 0x1f628, 0x1f62d, 0x1f614, 0x1f621, 0x1f62a,
        0x1f637, 0x1f625, 0x1f60a, 0x1f608, 0x1f9df, 0x1f606, 0x1f631, 0x1f609,
        0x1f62b, 0x1f633, 0x1f60e, 0x1f910, 0x1f47d, 0x1f913, 0x1f612, 0x1f44d,
        0x1f601, 0x1f60a,
      ],
    };
  },
  methods: {
    ...mapActions([
      "fetchUserMessages",
      "fetchUserTabMessages",
      "setNewMsgsCounter",
      "setPopupChat",
      "sendItemAttachment",
      "sendGroupAttachment",
      "fetchAttachment",
      "setReadNotification",
      "setReadGroupMessages",
      'setReadItemMessages',
      "setReadGarageMessages",
      "sendSystemNotification",
      "clearPopupChat",
      "pingMessages",
    ]),
    getChatImage(file) {
      if (file) {
        let fileName = file.substring(file.lastIndexOf("/") + 1);
        return `${Global.getServerDomain()}/images/user/chat-messages/${fileName}`;
      }
    },
    retrieveImageFromClipboard(pasteEvent, callback) {
      if (!pasteEvent.clipboardData) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      const items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      for (const item of items) {
        // Skip content if not image
        if (item.type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        const blob = item.getAsFile();
        if (typeof callback == "function") {
          callback(blob);
        }
      }
    },
    isChatUnread(msg) {
      const lastMessage = msg[msg.length - 1];
      if (lastMessage.senderId === this.loggedUser.id) {
        return false;
      }

      if (lastMessage.seen === 1) return false;
      return lastMessage.seen === 0
    },
    getLastMsg(messages) {
      const l = messages.length;
      return `${messages[l - 1].msg}`;
    },
    getLastMsgTimeStamp(messages) {
      const l = messages.length;
      return `${messages[l - 1].createdAt}`;
    },
    getSenderImgPath(user) {
      return `${Global.getServerDomain()}/images/user/${user.senderId}.jpg`;
    },
    getUserImgPath(user) {
      return `${Global.getServerDomain()}/images/user/${user.id}.jpg`;
    },
    getChatImgPath(user) {
      if (user.receiverId === -1) return "/img/favicon.png";
      return `${Global.getServerDomain()}/images/user/${user.senderId}.jpg`;
    },
    getReceiverImgPath(user) {
      return `${Global.getServerDomain()}/images/user/${user.receiverId}.jpg`;
    },
    getLastSenderMsg(messages) {
      let arr = [];
      arr = messages.filter((item) => {
        return item.senderId !== this.loggedUser.id;
      });
      return arr[arr.length - 1].msg;
    },

    getNewestMsgFromSender(msg) {
      if (msg[msg.length - 1]) {
        if (msg[msg.length - 1].senderId !== this.loggedUser.id) {
          return true;
        }
      }
      return false;
    },
    getSenderName(msg, user) {
      if (msg.senderId === this.loggedUser.id) {
        if (this.loggedUser.firstName) {
          return `${this.loggedUser.firstName}`;
        } else {
          return `${this.loggedUser.username}`;
        }
      } else {
        if (user.firstName) {
          return `${user.firstName}`;
        } else {
          return `${user.username}`;
        }
      }
    },
    getChatUsername(usr) {
      if (usr !== undefined) {
        if (usr.firstName) {
          return usr.firstName;
        } else if (usr.username) {
          return usr.username;
        }
      }
      return usr;
    },
    getAllMsgs(usr) {
      return usr?.messages ?? [];
    },
  },
  computed: {
    ...mapGetters({
      loggedUser: "getUser",
      userMessages: "getUserMessages",
      userTabMessages: "getUserTabMessages",
      stateWindow: "getStateWindowChat",
      chatMessages: "getWindowChatMsgs",
      systemNotification: "getSystemNotifications",
      getChatMessages: "getChatMessages",
      lastMsgFromChat: "getLastMsgFromChat",
      userMessagesCount: "getUserMessagesCount",
    }),
    filteredResults() {
      if (!this.filter) return this.userMessages;
      let pattern = new RegExp(this.filter.toLowerCase());
      const userMessages = this.userMessages || [];
      if (!Array.isArray(userMessages)) return [];
      let result = userMessages.filter((item) => {
        let firstname;
        let username;
        if (item.firstName) firstname = item.firstName.toLowerCase();
        if (item.username) username = item.username.toLowerCase();
        return pattern.exec(firstname) || pattern.exec(username);
      });
      return result;
    },
  },
  filters: {
    fileName(string) {
      if (string) {
        let fileName = string.substring(string.lastIndexOf("/") + 1);
        return fileName;
      }
    },
    date(date) {
      if (!date) return "";
      const dt = new Date(date);
      const f = (d) => (d < 10 ? "0" + d : d);
      return (
        f(dt.getMonth() + 1) + "/" + f(dt.getDate()) + "/" + dt.getFullYear()
      );
    },
    dateLong(date) {
      if (!date) return "";
      const dt = new Date(date);
      const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(dt);
      const mo = new Intl.DateTimeFormat("en", { month: "long" }).format(dt);
      const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(dt);
      return `${mo} ${da}, ${ye}`;
    },
    time(date) {
      const time = new Date(date);
      return time.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    },
    relativeDate(date) {
      if (!date) return "";

      const dt = moment(date);
      moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          w: "a week",
          ww: "%d weeks",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years",
        },
      });

      return dt.fromNow();
    },
  },
};
</script>
